import loadable from "@loadable/component"

export const Billing = loadable(() =>
  import(
    /* webpackChunkName: "billing-chunk" */
    /* webpackPrefetch: true */
    "@modules/billing/components/Billing"
  )
)
